import store from '@/store'
import router from '@/router'

/**
 * middleware: loadModules
 *
 * 用途： 把 modules 先讀取到 VUEX 供後續使用
 *
 * visit liff page -> loadModules middleware -> mount liff page
 */
export default async function loadModules({ next, to }) {
  if (! store.state.liffGeneral.orgCode) {
    store.commit('liffGeneral/SET_ORG_CODE', to.params.orgCode || to.params.org_code)
  }

  let modules = to.matched.filter((record) => record.meta.modules)
    .map((record) => record.meta.modules);

  modules = [].concat.apply([], modules)
  modules = [...new Set(modules)]

  for (let i = 0; i < modules.length; i ++) {
    let moduleCode = modules[i]
    try {
      await store.dispatch('liffModule/fetchModule', moduleCode)
    } catch (error) {
      console.error('fetchModule failed', error)
      const orgCode = to.params.org_code || to.params.orgCode
      return router.push({ name: 'LiffModuleNotYet', params: { orgCode: orgCode } })
    }
  }

  let extraModules = to.matched.filter((record) => record.meta.extraModules)
    .map((record) => record.meta.modules);

  extraModules = [].concat.apply([], extraModules)
  extraModules = [...new Set(extraModules)]

  for (let i = 0; i < extraModules.length; i ++) {
    let moduleCode = extraModules[i]
    try {
      await store.dispatch('liffModule/fetchModule', moduleCode)
    } catch (error) {
      console.error('fetchModule failed', error)
    }
  }
  return next()
}
